/** Canonical session id — minted by the edge function on covered pages, by session-manager otherwise. */
export const COOKIE_SESSION_ID = 'mf_sid';
/** Retired session cookie — read once for in-flight migration, then expired. */
export const COOKIE_SESSION_ID_LEGACY = 'mfSessionId';
/** One-shot fresh-mint marker set by the edge. Read-only here — event-listener-client owns its consumption. */
export const COOKIE_SESSION_NEW = 'mf_sid_new';
export const COOKIE_TRANSACTION_ID = 'transaction_id';
export const COOKIE_VISITOR_ID = 'mf_vid';
export const COOKIE_GEO = 'mf_geo';
export const STORAGE_KEY = 'ps_session';
export const SESSION_PARAM = 'mfsid';

export const DEFAULT_IDLE_TIMEOUT = 1800; // 30 minutes in seconds
export const VISITOR_ID_MAX_AGE = 365 * 24 * 60 * 60; // 1 year in seconds
export const DEFAULT_OUTLINK_SELECTOR = 'a.outlink, a.leave-behind';
export const MAX_SEQUENCE_LENGTH = 100;

/** Throttle interval for activity tracking updates (ms). */
export const ACTIVITY_THROTTLE_MS = 30_000;

/** Default timeout for IP/geo context resolution (ms). */
export const DEFAULT_CONTEXT_TIMEOUT = 3000;
